import { Row, Col, Table, Button, Radio, Tooltip, Input, Modal, modal,Spin } from "antd";

import React, { Component } from 'react';
import 'antd/dist/antd.css';

import { Redirect, Route } from "react-router-dom";
class Dialog extends Component {
    constructor(props) {
        super();

    }
    WarningDialog(content) {
        Modal.error({
            title: 'Warning',
            content: content,
        });
    }
    SuccessDialog(content, url) {
        Modal.success({
            title: 'Success',
            content: content,
            onOk: () => this.handleOK(url)
        });

    }

    SuccessDialogForDraft(content, url) {
        Modal.success({
            title: 'Success',
            content: content,
            onOk: () => this.handleOK(url)
        });

    }
    handleOK = url => {
        console.log(url);
        window.location.href = url
    };
    handleOKs = url=>{

        window.history.back();
    }


    componentDidMount() {
        console.log('in componentdidmount')
    }

    render() {
        return (
            //fake render
            <div>
                
            </div>
        )
    }
}
export default Dialog
